import React, { useState } from "react";
import Project from "../../components/Project/index.jsx";
import ProjectModal from "../../components/ProjectModal/index.jsx";
import Reveal from "../../components/Reveal/index.jsx";
import { Grid, Box, Typography, Container, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { tokens } from "../../theme";
import projects from "./projectsData.js";
import bannerImg from "../../images/projects/hockley-mills/01-elevation-railway.jpg";

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box sx={{ backgroundColor: colors.background[200] }}>
      <Box
        sx={{
          // Scrim matched to the home hero so the two banners read as one system.
          backgroundImage:
            `linear-gradient(180deg, rgba(8,12,20,.82) 0%, rgba(8,12,20,.58) 45%, rgba(8,12,20,.88) 100%), url(${bannerImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          py: { xs: 8, md: 12 },
          mb: { xs: 5, md: 8 }
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: 'white',
            px: { xs: 2, sm: 0 }
          }}
        >
          Our Projects
        </Typography>
        <Typography
          sx={{
            color: alpha('#ffffff', 0.88),
            mt: 2.5,
            maxWidth: 640,
            mx: 'auto',
            px: { xs: 2, sm: 3 },
            fontSize: { xs: '1.0625rem', md: '1.1875rem' },
            lineHeight: 1.6
          }}
        >
          A selection of facade installation packages delivered by AV Facade Services Ltd
          across residential, education, science and secure developments.
        </Typography>
      </Box>

      {/* The banner supplies the gap above the grid; this one keeps the last row of
          cards off the footer, matching the rhythm the Contact page uses. */}
      <Container maxWidth="xl" sx={{ pb: { xs: 7, md: 11 } }}>
        <Grid
          container
          spacing={{ xs: 3, sm: 3, md: 4 }}
          sx={{
            justifyContent: "center",
            px: { xs: 2, sm: 3, md: 4 }
          }}
        >
          {projects.map((project, index) => (
            <Grid item xs={12} sm={6} md={4} key={project.title}>
              {/* The stagger restarts each row so a long grid does not build up an
                  ever-growing delay towards the bottom. */}
              <Reveal index={index % 3} sx={{ height: '100%' }}>
                <Project
                  project={project}
                  onClick={() => setSelectedProject(project)}
                />
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>

      <ProjectModal
        open={!!selectedProject}
        onClose={() => setSelectedProject(null)}
        project={selectedProject}
      />
    </Box>
  );
};

export default Projects;
